import React          from 'react'
import ReactDOM       from 'react-dom'
import BaseController from 'controllers/base'
import                     'scrollpos-styler/scrollPosStyler.js'
import KeyFactsDocument from '../../containers/Calculators/KeyFactsDocument';

class Controller extends BaseController {
  call() {
    super.call();
    if (document.getElementById("react-root")) {
      ReactDOM.render(<KeyFactsDocument />, document.getElementById("react-root"))
    }
  }
}

export default Controller;
